shadow$provide[11] = function(require,module,exports) {

};